import { KeyboardEvent } from 'react'

export const replaceAllComas = (value: string): string => {
  return value.replace(/\./g, '')
}

/**
 * Handles keydown events for number inputs
 * Allows: digits 0-9, minus, plus, backspace, arrow keys, and tab
 * Prevents default for other keys or when minus/plus is used after text already exists
 */
export const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
  const allowedKeys = [
    '-',
    '+',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'Backspace',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
  ]

  if (allowedKeys.includes(event.key)) {
    // If there's existing text and user tries to add +/- sign, prevent it
    const targetValue = (event.target as HTMLInputElement).value
    if ((event.key === '-' || event.key === '+') && targetValue.length > 0) {
      event.preventDefault()
    }
    // Otherwise allow the keypress
    return
  }

  // Prevent default for any key not in the allowed list
  event.preventDefault()
}
